module.exports = __webpack_public_path__ + "static/media/device.341a28b0.svg";